/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MarketingRouteImport } from './routes/_marketing'
import { Route as AppRouteImport } from './routes/app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MailOptOutRouteImport } from './routes/mail-opt-out'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as MarketingIndexRouteImport } from './routes/_marketing.index'
import { Route as MarketingLangRouteImport } from './routes/_marketing.$lang'
import { Route as MarketingContactRouteImport } from './routes/_marketing.contact'
import { Route as MarketingFeaturesRouteImport } from './routes/_marketing.features'
import { Route as MarketingForWeddingPlannersRouteImport } from './routes/_marketing.for-wedding-planners'
import { Route as MarketingPlanAWeddingTogetherRouteImport } from './routes/_marketing.plan-a-wedding-together'
import { Route as MarketingPricingRouteImport } from './routes/_marketing.pricing'
import { Route as MarketingWeddingBudgetAppRouteImport } from './routes/_marketing.wedding-budget-app'
import { Route as MarketingWeddingBudgetCalculatorRouteImport } from './routes/_marketing.wedding-budget-calculator'
import { Route as MarketingWeddingChecklistRouteImport } from './routes/_marketing.wedding-checklist'
import { Route as MarketingWeddingCountdownRouteImport } from './routes/_marketing.wedding-countdown'
import { Route as MarketingWeddingDayTimelineRouteImport } from './routes/_marketing.wedding-day-timeline'
import { Route as MarketingWeddingGuestListAppRouteImport } from './routes/_marketing.wedding-guest-list-app'
import { Route as MarketingWeddingGuestListTemplateRouteImport } from './routes/_marketing.wedding-guest-list-template'
import { Route as MarketingWeddingRsvpRouteImport } from './routes/_marketing.wedding-rsvp'
import { Route as MarketingWeddingSeatingChartRouteImport } from './routes/_marketing.wedding-seating-chart'
import { Route as MarketingWhenToSendWeddingInvitationsRouteImport } from './routes/_marketing.when-to-send-wedding-invitations'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as AppAccountRouteImport } from './routes/app.account'
import { Route as AppBillingRouteImport } from './routes/app.billing'
import { Route as AppNewRouteImport } from './routes/app.new'
import { Route as AppPlannerRouteImport } from './routes/app.planner'
import { Route as AppTemplatesRouteImport } from './routes/app.templates'
import { Route as AuthAppReturnRouteImport } from './routes/auth.app-return'
import { Route as JoinTokenRouteImport } from './routes/join.$token'
import { Route as LegalIndexRouteImport } from './routes/legal.index'
import { Route as LegalCookiesRouteImport } from './routes/legal.cookies'
import { Route as LegalDeleteAccountRouteImport } from './routes/legal.delete-account'
import { Route as LegalPrivacyRouteImport } from './routes/legal.privacy'
import { Route as LegalTermsRouteImport } from './routes/legal.terms'
import { Route as RsvpTokenRouteImport } from './routes/rsvp.$token'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as MarketingLangIndexRouteImport } from './routes/_marketing.$lang.index'
import { Route as MarketingLangFeaturesRouteImport } from './routes/_marketing.$lang.features'
import { Route as MarketingLangPricingRouteImport } from './routes/_marketing.$lang.pricing'
import { Route as MarketingLangWeddingBudgetCalculatorRouteImport } from './routes/_marketing.$lang.wedding-budget-calculator'
import { Route as MarketingLangWeddingChecklistRouteImport } from './routes/_marketing.$lang.wedding-checklist'
import { Route as MarketingLangWeddingCountdownRouteImport } from './routes/_marketing.$lang.wedding-countdown'
import { Route as MarketingLangWeddingDayTimelineRouteImport } from './routes/_marketing.$lang.wedding-day-timeline'
import { Route as MarketingLangWeddingGuestListTemplateRouteImport } from './routes/_marketing.$lang.wedding-guest-list-template'
import { Route as MarketingLangWeddingSeatingChartRouteImport } from './routes/_marketing.$lang.wedding-seating-chart'
import { Route as MarketingLangWhenToSendWeddingInvitationsRouteImport } from './routes/_marketing.$lang.when-to-send-wedding-invitations'
import { Route as MarketingCompareBridebookAlternativeRouteImport } from './routes/_marketing.compare.bridebook-alternative'
import { Route as MarketingCompareTheKnotAlternativeRouteImport } from './routes/_marketing.compare.the-knot-alternative'
import { Route as MarketingCompareZolaAlternativeRouteImport } from './routes/_marketing.compare.zola-alternative'
import { Route as MarketingGuidesIndexRouteImport } from './routes/_marketing.guides.index'
import { Route as MarketingGuidesHowToMakeAWeddingSeatingChartRouteImport } from './routes/_marketing.guides.how-to-make-a-wedding-seating-chart'
import { Route as MarketingGuidesHowToPlanAWeddingRouteImport } from './routes/_marketing.guides.how-to-plan-a-wedding'
import { Route as MarketingGuidesQuestionsToAskWeddingVendorsRouteImport } from './routes/_marketing.guides.questions-to-ask-wedding-vendors'
import { Route as MarketingGuidesWeddingBudgetBreakdownRouteImport } from './routes/_marketing.guides.wedding-budget-breakdown'
import { Route as MarketingGuidesWeddingGuestListEtiquetteRouteImport } from './routes/_marketing.guides.wedding-guest-list-etiquette'
import { Route as MarketingGuidesWeddingRsvpWordingRouteImport } from './routes/_marketing.guides.wedding-rsvp-wording'
import { Route as MarketingHelpIndexRouteImport } from './routes/_marketing.help.index'
import { Route as MarketingHelpImportGuestListRouteImport } from './routes/_marketing.help.import-guest-list'
import { Route as MarketingHelpInviteYourPartnerRouteImport } from './routes/_marketing.help.invite-your-partner'
import { Route as MarketingHelpMoveRouteImport } from './routes/_marketing.help.move'
import { Route as MarketingHelpRsvpLinksRouteImport } from './routes/_marketing.help.rsvp-links'
import { Route as MarketingWeddingChecklist3MonthsRouteImport } from './routes/_marketing.wedding-checklist_.3-months'
import { Route as MarketingWeddingChecklist6MonthsRouteImport } from './routes/_marketing.wedding-checklist_.6-months'
import { Route as MarketingWeddingDayTimeline2pmCeremonyRouteImport } from './routes/_marketing.wedding-day-timeline_.2pm-ceremony'
import { Route as MarketingWeddingDayTimeline4pmCeremonyRouteImport } from './routes/_marketing.wedding-day-timeline_.4pm-ceremony'
import { Route as MarketingWeddingDayTimeline6pmCeremonyRouteImport } from './routes/_marketing.wedding-day-timeline_.6pm-ceremony'
import { Route as AppWWeddingIdRouteImport } from './routes/app.w.$weddingId'
import { Route as AppWWeddingIdIndexRouteImport } from './routes/app.w.$weddingId.index'
import { Route as AppWWeddingIdActivityRouteImport } from './routes/app.w.$weddingId.activity'
import { Route as AppWWeddingIdBudgetRouteImport } from './routes/app.w.$weddingId.budget'
import { Route as AppWWeddingIdChecklistRouteImport } from './routes/app.w.$weddingId.checklist'
import { Route as AppWWeddingIdGuestsRouteImport } from './routes/app.w.$weddingId.guests'
import { Route as AppWWeddingIdInsightsRouteImport } from './routes/app.w.$weddingId.insights'
import { Route as AppWWeddingIdInspirationRouteImport } from './routes/app.w.$weddingId.inspiration'
import { Route as AppWWeddingIdMoreRouteImport } from './routes/app.w.$weddingId.more'
import { Route as AppWWeddingIdNotesRouteImport } from './routes/app.w.$weddingId.notes'
import { Route as AppWWeddingIdPaymentsRouteImport } from './routes/app.w.$weddingId.payments'
import { Route as AppWWeddingIdPeopleRouteImport } from './routes/app.w.$weddingId.people'
import { Route as AppWWeddingIdRegistryRouteImport } from './routes/app.w.$weddingId.registry'
import { Route as AppWWeddingIdSeatingRouteImport } from './routes/app.w.$weddingId.seating'
import { Route as AppWWeddingIdSettingsRouteImport } from './routes/app.w.$weddingId.settings'
import { Route as AppWWeddingIdShoppingRouteImport } from './routes/app.w.$weddingId.shopping'
import { Route as AppWWeddingIdTimelineRouteImport } from './routes/app.w.$weddingId.timeline'
import { Route as AppWWeddingIdVendorsRouteImport } from './routes/app.w.$weddingId.vendors'
import { Route as AppWWeddingIdPrintKindRouteImport } from './routes/app.w.$weddingId_.print.$kind'

const MarketingRoute = MarketingRouteImport.update({
  id: '/_marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MailOptOutRoute = MailOptOutRouteImport.update({
  id: '/mail-opt-out',
  path: '/mail-opt-out',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeRoute = UnsubscribeRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingIndexRoute = MarketingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingLangRoute = MarketingLangRouteImport.update({
  id: '/$lang',
  path: '/$lang',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingContactRoute = MarketingContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingFeaturesRoute = MarketingFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingForWeddingPlannersRoute =
  MarketingForWeddingPlannersRouteImport.update({
    id: '/for-wedding-planners',
    path: '/for-wedding-planners',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingPlanAWeddingTogetherRoute =
  MarketingPlanAWeddingTogetherRouteImport.update({
    id: '/plan-a-wedding-together',
    path: '/plan-a-wedding-together',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingPricingRoute = MarketingPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingWeddingBudgetAppRoute =
  MarketingWeddingBudgetAppRouteImport.update({
    id: '/wedding-budget-app',
    path: '/wedding-budget-app',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingWeddingBudgetCalculatorRoute =
  MarketingWeddingBudgetCalculatorRouteImport.update({
    id: '/wedding-budget-calculator',
    path: '/wedding-budget-calculator',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingWeddingChecklistRoute =
  MarketingWeddingChecklistRouteImport.update({
    id: '/wedding-checklist',
    path: '/wedding-checklist',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingWeddingCountdownRoute =
  MarketingWeddingCountdownRouteImport.update({
    id: '/wedding-countdown',
    path: '/wedding-countdown',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingWeddingDayTimelineRoute =
  MarketingWeddingDayTimelineRouteImport.update({
    id: '/wedding-day-timeline',
    path: '/wedding-day-timeline',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingWeddingGuestListAppRoute =
  MarketingWeddingGuestListAppRouteImport.update({
    id: '/wedding-guest-list-app',
    path: '/wedding-guest-list-app',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingWeddingGuestListTemplateRoute =
  MarketingWeddingGuestListTemplateRouteImport.update({
    id: '/wedding-guest-list-template',
    path: '/wedding-guest-list-template',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingWeddingRsvpRoute = MarketingWeddingRsvpRouteImport.update({
  id: '/wedding-rsvp',
  path: '/wedding-rsvp',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingWeddingSeatingChartRoute =
  MarketingWeddingSeatingChartRouteImport.update({
    id: '/wedding-seating-chart',
    path: '/wedding-seating-chart',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingWhenToSendWeddingInvitationsRoute =
  MarketingWhenToSendWeddingInvitationsRouteImport.update({
    id: '/when-to-send-wedding-invitations',
    path: '/when-to-send-wedding-invitations',
    getParentRoute: () => MarketingRoute,
  } as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppNewRoute = AppNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppRoute,
} as any)
const AppPlannerRoute = AppPlannerRouteImport.update({
  id: '/planner',
  path: '/planner',
  getParentRoute: () => AppRoute,
} as any)
const AppTemplatesRoute = AppTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppRoute,
} as any)
const AuthAppReturnRoute = AuthAppReturnRouteImport.update({
  id: '/auth/app-return',
  path: '/auth/app-return',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinTokenRoute = JoinTokenRouteImport.update({
  id: '/join/$token',
  path: '/join/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalIndexRoute = LegalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LegalRoute,
} as any)
const LegalCookiesRoute = LegalCookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => LegalRoute,
} as any)
const LegalDeleteAccountRoute = LegalDeleteAccountRouteImport.update({
  id: '/delete-account',
  path: '/delete-account',
  getParentRoute: () => LegalRoute,
} as any)
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => LegalRoute,
} as any)
const LegalTermsRoute = LegalTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => LegalRoute,
} as any)
const RsvpTokenRoute = RsvpTokenRouteImport.update({
  id: '/rsvp/$token',
  path: '/rsvp/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingLangIndexRoute = MarketingLangIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketingLangRoute,
} as any)
const MarketingLangFeaturesRoute = MarketingLangFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => MarketingLangRoute,
} as any)
const MarketingLangPricingRoute = MarketingLangPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => MarketingLangRoute,
} as any)
const MarketingLangWeddingBudgetCalculatorRoute =
  MarketingLangWeddingBudgetCalculatorRouteImport.update({
    id: '/wedding-budget-calculator',
    path: '/wedding-budget-calculator',
    getParentRoute: () => MarketingLangRoute,
  } as any)
const MarketingLangWeddingChecklistRoute =
  MarketingLangWeddingChecklistRouteImport.update({
    id: '/wedding-checklist',
    path: '/wedding-checklist',
    getParentRoute: () => MarketingLangRoute,
  } as any)
const MarketingLangWeddingCountdownRoute =
  MarketingLangWeddingCountdownRouteImport.update({
    id: '/wedding-countdown',
    path: '/wedding-countdown',
    getParentRoute: () => MarketingLangRoute,
  } as any)
const MarketingLangWeddingDayTimelineRoute =
  MarketingLangWeddingDayTimelineRouteImport.update({
    id: '/wedding-day-timeline',
    path: '/wedding-day-timeline',
    getParentRoute: () => MarketingLangRoute,
  } as any)
const MarketingLangWeddingGuestListTemplateRoute =
  MarketingLangWeddingGuestListTemplateRouteImport.update({
    id: '/wedding-guest-list-template',
    path: '/wedding-guest-list-template',
    getParentRoute: () => MarketingLangRoute,
  } as any)
const MarketingLangWeddingSeatingChartRoute =
  MarketingLangWeddingSeatingChartRouteImport.update({
    id: '/wedding-seating-chart',
    path: '/wedding-seating-chart',
    getParentRoute: () => MarketingLangRoute,
  } as any)
const MarketingLangWhenToSendWeddingInvitationsRoute =
  MarketingLangWhenToSendWeddingInvitationsRouteImport.update({
    id: '/when-to-send-wedding-invitations',
    path: '/when-to-send-wedding-invitations',
    getParentRoute: () => MarketingLangRoute,
  } as any)
const MarketingCompareBridebookAlternativeRoute =
  MarketingCompareBridebookAlternativeRouteImport.update({
    id: '/compare/bridebook-alternative',
    path: '/compare/bridebook-alternative',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingCompareTheKnotAlternativeRoute =
  MarketingCompareTheKnotAlternativeRouteImport.update({
    id: '/compare/the-knot-alternative',
    path: '/compare/the-knot-alternative',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingCompareZolaAlternativeRoute =
  MarketingCompareZolaAlternativeRouteImport.update({
    id: '/compare/zola-alternative',
    path: '/compare/zola-alternative',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingGuidesIndexRoute = MarketingGuidesIndexRouteImport.update({
  id: '/guides/',
  path: '/guides/',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingGuidesHowToMakeAWeddingSeatingChartRoute =
  MarketingGuidesHowToMakeAWeddingSeatingChartRouteImport.update({
    id: '/guides/how-to-make-a-wedding-seating-chart',
    path: '/guides/how-to-make-a-wedding-seating-chart',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingGuidesHowToPlanAWeddingRoute =
  MarketingGuidesHowToPlanAWeddingRouteImport.update({
    id: '/guides/how-to-plan-a-wedding',
    path: '/guides/how-to-plan-a-wedding',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingGuidesQuestionsToAskWeddingVendorsRoute =
  MarketingGuidesQuestionsToAskWeddingVendorsRouteImport.update({
    id: '/guides/questions-to-ask-wedding-vendors',
    path: '/guides/questions-to-ask-wedding-vendors',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingGuidesWeddingBudgetBreakdownRoute =
  MarketingGuidesWeddingBudgetBreakdownRouteImport.update({
    id: '/guides/wedding-budget-breakdown',
    path: '/guides/wedding-budget-breakdown',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingGuidesWeddingGuestListEtiquetteRoute =
  MarketingGuidesWeddingGuestListEtiquetteRouteImport.update({
    id: '/guides/wedding-guest-list-etiquette',
    path: '/guides/wedding-guest-list-etiquette',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingGuidesWeddingRsvpWordingRoute =
  MarketingGuidesWeddingRsvpWordingRouteImport.update({
    id: '/guides/wedding-rsvp-wording',
    path: '/guides/wedding-rsvp-wording',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingHelpIndexRoute = MarketingHelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingHelpImportGuestListRoute =
  MarketingHelpImportGuestListRouteImport.update({
    id: '/help/import-guest-list',
    path: '/help/import-guest-list',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingHelpInviteYourPartnerRoute =
  MarketingHelpInviteYourPartnerRouteImport.update({
    id: '/help/invite-your-partner',
    path: '/help/invite-your-partner',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingHelpMoveRoute = MarketingHelpMoveRouteImport.update({
  id: '/help/move',
  path: '/help/move',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingHelpRsvpLinksRoute = MarketingHelpRsvpLinksRouteImport.update({
  id: '/help/rsvp-links',
  path: '/help/rsvp-links',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingWeddingChecklist3MonthsRoute =
  MarketingWeddingChecklist3MonthsRouteImport.update({
    id: '/wedding-checklist_/3-months',
    path: '/wedding-checklist/3-months',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingWeddingChecklist6MonthsRoute =
  MarketingWeddingChecklist6MonthsRouteImport.update({
    id: '/wedding-checklist_/6-months',
    path: '/wedding-checklist/6-months',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingWeddingDayTimeline2pmCeremonyRoute =
  MarketingWeddingDayTimeline2pmCeremonyRouteImport.update({
    id: '/wedding-day-timeline_/2pm-ceremony',
    path: '/wedding-day-timeline/2pm-ceremony',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingWeddingDayTimeline4pmCeremonyRoute =
  MarketingWeddingDayTimeline4pmCeremonyRouteImport.update({
    id: '/wedding-day-timeline_/4pm-ceremony',
    path: '/wedding-day-timeline/4pm-ceremony',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingWeddingDayTimeline6pmCeremonyRoute =
  MarketingWeddingDayTimeline6pmCeremonyRouteImport.update({
    id: '/wedding-day-timeline_/6pm-ceremony',
    path: '/wedding-day-timeline/6pm-ceremony',
    getParentRoute: () => MarketingRoute,
  } as any)
const AppWWeddingIdRoute = AppWWeddingIdRouteImport.update({
  id: '/w/$weddingId',
  path: '/w/$weddingId',
  getParentRoute: () => AppRoute,
} as any)
const AppWWeddingIdIndexRoute = AppWWeddingIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdActivityRoute = AppWWeddingIdActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdBudgetRoute = AppWWeddingIdBudgetRouteImport.update({
  id: '/budget',
  path: '/budget',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdChecklistRoute = AppWWeddingIdChecklistRouteImport.update({
  id: '/checklist',
  path: '/checklist',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdGuestsRoute = AppWWeddingIdGuestsRouteImport.update({
  id: '/guests',
  path: '/guests',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdInsightsRoute = AppWWeddingIdInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdInspirationRoute =
  AppWWeddingIdInspirationRouteImport.update({
    id: '/inspiration',
    path: '/inspiration',
    getParentRoute: () => AppWWeddingIdRoute,
  } as any)
const AppWWeddingIdMoreRoute = AppWWeddingIdMoreRouteImport.update({
  id: '/more',
  path: '/more',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdNotesRoute = AppWWeddingIdNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdPaymentsRoute = AppWWeddingIdPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdPeopleRoute = AppWWeddingIdPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdRegistryRoute = AppWWeddingIdRegistryRouteImport.update({
  id: '/registry',
  path: '/registry',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdSeatingRoute = AppWWeddingIdSeatingRouteImport.update({
  id: '/seating',
  path: '/seating',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdSettingsRoute = AppWWeddingIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdShoppingRoute = AppWWeddingIdShoppingRouteImport.update({
  id: '/shopping',
  path: '/shopping',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdTimelineRoute = AppWWeddingIdTimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdVendorsRoute = AppWWeddingIdVendorsRouteImport.update({
  id: '/vendors',
  path: '/vendors',
  getParentRoute: () => AppWWeddingIdRoute,
} as any)
const AppWWeddingIdPrintKindRoute = AppWWeddingIdPrintKindRouteImport.update({
  id: '/w/$weddingId_/print/$kind',
  path: '/w/$weddingId/print/$kind',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof MarketingIndexRoute
  '/app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/legal': typeof LegalRouteWithChildren
  '/login': typeof LoginRoute
  '/mail-opt-out': typeof MailOptOutRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/$lang': typeof MarketingLangRouteWithChildren
  '/contact': typeof MarketingContactRoute
  '/features': typeof MarketingFeaturesRoute
  '/for-wedding-planners': typeof MarketingForWeddingPlannersRoute
  '/plan-a-wedding-together': typeof MarketingPlanAWeddingTogetherRoute
  '/pricing': typeof MarketingPricingRoute
  '/wedding-budget-app': typeof MarketingWeddingBudgetAppRoute
  '/wedding-budget-calculator': typeof MarketingWeddingBudgetCalculatorRoute
  '/wedding-checklist': typeof MarketingWeddingChecklistRoute
  '/wedding-countdown': typeof MarketingWeddingCountdownRoute
  '/wedding-day-timeline': typeof MarketingWeddingDayTimelineRoute
  '/wedding-guest-list-app': typeof MarketingWeddingGuestListAppRoute
  '/wedding-guest-list-template': typeof MarketingWeddingGuestListTemplateRoute
  '/wedding-rsvp': typeof MarketingWeddingRsvpRoute
  '/wedding-seating-chart': typeof MarketingWeddingSeatingChartRoute
  '/when-to-send-wedding-invitations': typeof MarketingWhenToSendWeddingInvitationsRoute
  '/app/account': typeof AppAccountRoute
  '/app/billing': typeof AppBillingRoute
  '/app/new': typeof AppNewRoute
  '/app/planner': typeof AppPlannerRoute
  '/app/templates': typeof AppTemplatesRoute
  '/auth/app-return': typeof AuthAppReturnRoute
  '/join/$token': typeof JoinTokenRoute
  '/legal/cookies': typeof LegalCookiesRoute
  '/legal/delete-account': typeof LegalDeleteAccountRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/rsvp/$token': typeof RsvpTokenRoute
  '/s/$token': typeof STokenRoute
  '/app/': typeof AppIndexRoute
  '/legal/': typeof LegalIndexRoute
  '/$lang/features': typeof MarketingLangFeaturesRoute
  '/$lang/pricing': typeof MarketingLangPricingRoute
  '/$lang/wedding-budget-calculator': typeof MarketingLangWeddingBudgetCalculatorRoute
  '/$lang/wedding-checklist': typeof MarketingLangWeddingChecklistRoute
  '/$lang/wedding-countdown': typeof MarketingLangWeddingCountdownRoute
  '/$lang/wedding-day-timeline': typeof MarketingLangWeddingDayTimelineRoute
  '/$lang/wedding-guest-list-template': typeof MarketingLangWeddingGuestListTemplateRoute
  '/$lang/wedding-seating-chart': typeof MarketingLangWeddingSeatingChartRoute
  '/$lang/when-to-send-wedding-invitations': typeof MarketingLangWhenToSendWeddingInvitationsRoute
  '/compare/bridebook-alternative': typeof MarketingCompareBridebookAlternativeRoute
  '/compare/the-knot-alternative': typeof MarketingCompareTheKnotAlternativeRoute
  '/compare/zola-alternative': typeof MarketingCompareZolaAlternativeRoute
  '/guides/how-to-make-a-wedding-seating-chart': typeof MarketingGuidesHowToMakeAWeddingSeatingChartRoute
  '/guides/how-to-plan-a-wedding': typeof MarketingGuidesHowToPlanAWeddingRoute
  '/guides/questions-to-ask-wedding-vendors': typeof MarketingGuidesQuestionsToAskWeddingVendorsRoute
  '/guides/wedding-budget-breakdown': typeof MarketingGuidesWeddingBudgetBreakdownRoute
  '/guides/wedding-guest-list-etiquette': typeof MarketingGuidesWeddingGuestListEtiquetteRoute
  '/guides/wedding-rsvp-wording': typeof MarketingGuidesWeddingRsvpWordingRoute
  '/help/import-guest-list': typeof MarketingHelpImportGuestListRoute
  '/help/invite-your-partner': typeof MarketingHelpInviteYourPartnerRoute
  '/help/move': typeof MarketingHelpMoveRoute
  '/help/rsvp-links': typeof MarketingHelpRsvpLinksRoute
  '/wedding-checklist/3-months': typeof MarketingWeddingChecklist3MonthsRoute
  '/wedding-checklist/6-months': typeof MarketingWeddingChecklist6MonthsRoute
  '/wedding-day-timeline/2pm-ceremony': typeof MarketingWeddingDayTimeline2pmCeremonyRoute
  '/wedding-day-timeline/4pm-ceremony': typeof MarketingWeddingDayTimeline4pmCeremonyRoute
  '/wedding-day-timeline/6pm-ceremony': typeof MarketingWeddingDayTimeline6pmCeremonyRoute
  '/app/w/$weddingId': typeof AppWWeddingIdRouteWithChildren
  '/$lang/': typeof MarketingLangIndexRoute
  '/guides/': typeof MarketingGuidesIndexRoute
  '/help/': typeof MarketingHelpIndexRoute
  '/app/w/$weddingId/activity': typeof AppWWeddingIdActivityRoute
  '/app/w/$weddingId/budget': typeof AppWWeddingIdBudgetRoute
  '/app/w/$weddingId/checklist': typeof AppWWeddingIdChecklistRoute
  '/app/w/$weddingId/guests': typeof AppWWeddingIdGuestsRoute
  '/app/w/$weddingId/insights': typeof AppWWeddingIdInsightsRoute
  '/app/w/$weddingId/inspiration': typeof AppWWeddingIdInspirationRoute
  '/app/w/$weddingId/more': typeof AppWWeddingIdMoreRoute
  '/app/w/$weddingId/notes': typeof AppWWeddingIdNotesRoute
  '/app/w/$weddingId/payments': typeof AppWWeddingIdPaymentsRoute
  '/app/w/$weddingId/people': typeof AppWWeddingIdPeopleRoute
  '/app/w/$weddingId/registry': typeof AppWWeddingIdRegistryRoute
  '/app/w/$weddingId/seating': typeof AppWWeddingIdSeatingRoute
  '/app/w/$weddingId/settings': typeof AppWWeddingIdSettingsRoute
  '/app/w/$weddingId/shopping': typeof AppWWeddingIdShoppingRoute
  '/app/w/$weddingId/timeline': typeof AppWWeddingIdTimelineRoute
  '/app/w/$weddingId/vendors': typeof AppWWeddingIdVendorsRoute
  '/app/w/$weddingId/': typeof AppWWeddingIdIndexRoute
  '/app/w/$weddingId/print/$kind': typeof AppWWeddingIdPrintKindRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/mail-opt-out': typeof MailOptOutRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/contact': typeof MarketingContactRoute
  '/features': typeof MarketingFeaturesRoute
  '/for-wedding-planners': typeof MarketingForWeddingPlannersRoute
  '/plan-a-wedding-together': typeof MarketingPlanAWeddingTogetherRoute
  '/pricing': typeof MarketingPricingRoute
  '/wedding-budget-app': typeof MarketingWeddingBudgetAppRoute
  '/wedding-budget-calculator': typeof MarketingWeddingBudgetCalculatorRoute
  '/wedding-checklist': typeof MarketingWeddingChecklistRoute
  '/wedding-countdown': typeof MarketingWeddingCountdownRoute
  '/wedding-day-timeline': typeof MarketingWeddingDayTimelineRoute
  '/wedding-guest-list-app': typeof MarketingWeddingGuestListAppRoute
  '/wedding-guest-list-template': typeof MarketingWeddingGuestListTemplateRoute
  '/wedding-rsvp': typeof MarketingWeddingRsvpRoute
  '/wedding-seating-chart': typeof MarketingWeddingSeatingChartRoute
  '/when-to-send-wedding-invitations': typeof MarketingWhenToSendWeddingInvitationsRoute
  '/app/account': typeof AppAccountRoute
  '/app/billing': typeof AppBillingRoute
  '/app/new': typeof AppNewRoute
  '/app/planner': typeof AppPlannerRoute
  '/app/templates': typeof AppTemplatesRoute
  '/auth/app-return': typeof AuthAppReturnRoute
  '/join/$token': typeof JoinTokenRoute
  '/legal/cookies': typeof LegalCookiesRoute
  '/legal/delete-account': typeof LegalDeleteAccountRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/rsvp/$token': typeof RsvpTokenRoute
  '/s/$token': typeof STokenRoute
  '/': typeof MarketingIndexRoute
  '/app': typeof AppIndexRoute
  '/legal': typeof LegalIndexRoute
  '/$lang/features': typeof MarketingLangFeaturesRoute
  '/$lang/pricing': typeof MarketingLangPricingRoute
  '/$lang/wedding-budget-calculator': typeof MarketingLangWeddingBudgetCalculatorRoute
  '/$lang/wedding-checklist': typeof MarketingLangWeddingChecklistRoute
  '/$lang/wedding-countdown': typeof MarketingLangWeddingCountdownRoute
  '/$lang/wedding-day-timeline': typeof MarketingLangWeddingDayTimelineRoute
  '/$lang/wedding-guest-list-template': typeof MarketingLangWeddingGuestListTemplateRoute
  '/$lang/wedding-seating-chart': typeof MarketingLangWeddingSeatingChartRoute
  '/$lang/when-to-send-wedding-invitations': typeof MarketingLangWhenToSendWeddingInvitationsRoute
  '/compare/bridebook-alternative': typeof MarketingCompareBridebookAlternativeRoute
  '/compare/the-knot-alternative': typeof MarketingCompareTheKnotAlternativeRoute
  '/compare/zola-alternative': typeof MarketingCompareZolaAlternativeRoute
  '/guides/how-to-make-a-wedding-seating-chart': typeof MarketingGuidesHowToMakeAWeddingSeatingChartRoute
  '/guides/how-to-plan-a-wedding': typeof MarketingGuidesHowToPlanAWeddingRoute
  '/guides/questions-to-ask-wedding-vendors': typeof MarketingGuidesQuestionsToAskWeddingVendorsRoute
  '/guides/wedding-budget-breakdown': typeof MarketingGuidesWeddingBudgetBreakdownRoute
  '/guides/wedding-guest-list-etiquette': typeof MarketingGuidesWeddingGuestListEtiquetteRoute
  '/guides/wedding-rsvp-wording': typeof MarketingGuidesWeddingRsvpWordingRoute
  '/help/import-guest-list': typeof MarketingHelpImportGuestListRoute
  '/help/invite-your-partner': typeof MarketingHelpInviteYourPartnerRoute
  '/help/move': typeof MarketingHelpMoveRoute
  '/help/rsvp-links': typeof MarketingHelpRsvpLinksRoute
  '/wedding-checklist/3-months': typeof MarketingWeddingChecklist3MonthsRoute
  '/wedding-checklist/6-months': typeof MarketingWeddingChecklist6MonthsRoute
  '/wedding-day-timeline/2pm-ceremony': typeof MarketingWeddingDayTimeline2pmCeremonyRoute
  '/wedding-day-timeline/4pm-ceremony': typeof MarketingWeddingDayTimeline4pmCeremonyRoute
  '/wedding-day-timeline/6pm-ceremony': typeof MarketingWeddingDayTimeline6pmCeremonyRoute
  '/$lang': typeof MarketingLangIndexRoute
  '/guides': typeof MarketingGuidesIndexRoute
  '/help': typeof MarketingHelpIndexRoute
  '/app/w/$weddingId/activity': typeof AppWWeddingIdActivityRoute
  '/app/w/$weddingId/budget': typeof AppWWeddingIdBudgetRoute
  '/app/w/$weddingId/checklist': typeof AppWWeddingIdChecklistRoute
  '/app/w/$weddingId/guests': typeof AppWWeddingIdGuestsRoute
  '/app/w/$weddingId/insights': typeof AppWWeddingIdInsightsRoute
  '/app/w/$weddingId/inspiration': typeof AppWWeddingIdInspirationRoute
  '/app/w/$weddingId/more': typeof AppWWeddingIdMoreRoute
  '/app/w/$weddingId/notes': typeof AppWWeddingIdNotesRoute
  '/app/w/$weddingId/payments': typeof AppWWeddingIdPaymentsRoute
  '/app/w/$weddingId/people': typeof AppWWeddingIdPeopleRoute
  '/app/w/$weddingId/registry': typeof AppWWeddingIdRegistryRoute
  '/app/w/$weddingId/seating': typeof AppWWeddingIdSeatingRoute
  '/app/w/$weddingId/settings': typeof AppWWeddingIdSettingsRoute
  '/app/w/$weddingId/shopping': typeof AppWWeddingIdShoppingRoute
  '/app/w/$weddingId/timeline': typeof AppWWeddingIdTimelineRoute
  '/app/w/$weddingId/vendors': typeof AppWWeddingIdVendorsRoute
  '/app/w/$weddingId': typeof AppWWeddingIdIndexRoute
  '/app/w/$weddingId/print/$kind': typeof AppWWeddingIdPrintKindRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_marketing': typeof MarketingRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/legal': typeof LegalRouteWithChildren
  '/login': typeof LoginRoute
  '/mail-opt-out': typeof MailOptOutRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/_marketing/$lang': typeof MarketingLangRouteWithChildren
  '/_marketing/contact': typeof MarketingContactRoute
  '/_marketing/features': typeof MarketingFeaturesRoute
  '/_marketing/for-wedding-planners': typeof MarketingForWeddingPlannersRoute
  '/_marketing/plan-a-wedding-together': typeof MarketingPlanAWeddingTogetherRoute
  '/_marketing/pricing': typeof MarketingPricingRoute
  '/_marketing/wedding-budget-app': typeof MarketingWeddingBudgetAppRoute
  '/_marketing/wedding-budget-calculator': typeof MarketingWeddingBudgetCalculatorRoute
  '/_marketing/wedding-checklist': typeof MarketingWeddingChecklistRoute
  '/_marketing/wedding-countdown': typeof MarketingWeddingCountdownRoute
  '/_marketing/wedding-day-timeline': typeof MarketingWeddingDayTimelineRoute
  '/_marketing/wedding-guest-list-app': typeof MarketingWeddingGuestListAppRoute
  '/_marketing/wedding-guest-list-template': typeof MarketingWeddingGuestListTemplateRoute
  '/_marketing/wedding-rsvp': typeof MarketingWeddingRsvpRoute
  '/_marketing/wedding-seating-chart': typeof MarketingWeddingSeatingChartRoute
  '/_marketing/when-to-send-wedding-invitations': typeof MarketingWhenToSendWeddingInvitationsRoute
  '/app/account': typeof AppAccountRoute
  '/app/billing': typeof AppBillingRoute
  '/app/new': typeof AppNewRoute
  '/app/planner': typeof AppPlannerRoute
  '/app/templates': typeof AppTemplatesRoute
  '/auth/app-return': typeof AuthAppReturnRoute
  '/join/$token': typeof JoinTokenRoute
  '/legal/cookies': typeof LegalCookiesRoute
  '/legal/delete-account': typeof LegalDeleteAccountRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/rsvp/$token': typeof RsvpTokenRoute
  '/s/$token': typeof STokenRoute
  '/_marketing/': typeof MarketingIndexRoute
  '/app/': typeof AppIndexRoute
  '/legal/': typeof LegalIndexRoute
  '/_marketing/$lang/features': typeof MarketingLangFeaturesRoute
  '/_marketing/$lang/pricing': typeof MarketingLangPricingRoute
  '/_marketing/$lang/wedding-budget-calculator': typeof MarketingLangWeddingBudgetCalculatorRoute
  '/_marketing/$lang/wedding-checklist': typeof MarketingLangWeddingChecklistRoute
  '/_marketing/$lang/wedding-countdown': typeof MarketingLangWeddingCountdownRoute
  '/_marketing/$lang/wedding-day-timeline': typeof MarketingLangWeddingDayTimelineRoute
  '/_marketing/$lang/wedding-guest-list-template': typeof MarketingLangWeddingGuestListTemplateRoute
  '/_marketing/$lang/wedding-seating-chart': typeof MarketingLangWeddingSeatingChartRoute
  '/_marketing/$lang/when-to-send-wedding-invitations': typeof MarketingLangWhenToSendWeddingInvitationsRoute
  '/_marketing/compare/bridebook-alternative': typeof MarketingCompareBridebookAlternativeRoute
  '/_marketing/compare/the-knot-alternative': typeof MarketingCompareTheKnotAlternativeRoute
  '/_marketing/compare/zola-alternative': typeof MarketingCompareZolaAlternativeRoute
  '/_marketing/guides/how-to-make-a-wedding-seating-chart': typeof MarketingGuidesHowToMakeAWeddingSeatingChartRoute
  '/_marketing/guides/how-to-plan-a-wedding': typeof MarketingGuidesHowToPlanAWeddingRoute
  '/_marketing/guides/questions-to-ask-wedding-vendors': typeof MarketingGuidesQuestionsToAskWeddingVendorsRoute
  '/_marketing/guides/wedding-budget-breakdown': typeof MarketingGuidesWeddingBudgetBreakdownRoute
  '/_marketing/guides/wedding-guest-list-etiquette': typeof MarketingGuidesWeddingGuestListEtiquetteRoute
  '/_marketing/guides/wedding-rsvp-wording': typeof MarketingGuidesWeddingRsvpWordingRoute
  '/_marketing/help/import-guest-list': typeof MarketingHelpImportGuestListRoute
  '/_marketing/help/invite-your-partner': typeof MarketingHelpInviteYourPartnerRoute
  '/_marketing/help/move': typeof MarketingHelpMoveRoute
  '/_marketing/help/rsvp-links': typeof MarketingHelpRsvpLinksRoute
  '/_marketing/wedding-checklist_/3-months': typeof MarketingWeddingChecklist3MonthsRoute
  '/_marketing/wedding-checklist_/6-months': typeof MarketingWeddingChecklist6MonthsRoute
  '/_marketing/wedding-day-timeline_/2pm-ceremony': typeof MarketingWeddingDayTimeline2pmCeremonyRoute
  '/_marketing/wedding-day-timeline_/4pm-ceremony': typeof MarketingWeddingDayTimeline4pmCeremonyRoute
  '/_marketing/wedding-day-timeline_/6pm-ceremony': typeof MarketingWeddingDayTimeline6pmCeremonyRoute
  '/app/w/$weddingId': typeof AppWWeddingIdRouteWithChildren
  '/_marketing/$lang/': typeof MarketingLangIndexRoute
  '/_marketing/guides/': typeof MarketingGuidesIndexRoute
  '/_marketing/help/': typeof MarketingHelpIndexRoute
  '/app/w/$weddingId/activity': typeof AppWWeddingIdActivityRoute
  '/app/w/$weddingId/budget': typeof AppWWeddingIdBudgetRoute
  '/app/w/$weddingId/checklist': typeof AppWWeddingIdChecklistRoute
  '/app/w/$weddingId/guests': typeof AppWWeddingIdGuestsRoute
  '/app/w/$weddingId/insights': typeof AppWWeddingIdInsightsRoute
  '/app/w/$weddingId/inspiration': typeof AppWWeddingIdInspirationRoute
  '/app/w/$weddingId/more': typeof AppWWeddingIdMoreRoute
  '/app/w/$weddingId/notes': typeof AppWWeddingIdNotesRoute
  '/app/w/$weddingId/payments': typeof AppWWeddingIdPaymentsRoute
  '/app/w/$weddingId/people': typeof AppWWeddingIdPeopleRoute
  '/app/w/$weddingId/registry': typeof AppWWeddingIdRegistryRoute
  '/app/w/$weddingId/seating': typeof AppWWeddingIdSeatingRoute
  '/app/w/$weddingId/settings': typeof AppWWeddingIdSettingsRoute
  '/app/w/$weddingId/shopping': typeof AppWWeddingIdShoppingRoute
  '/app/w/$weddingId/timeline': typeof AppWWeddingIdTimelineRoute
  '/app/w/$weddingId/vendors': typeof AppWWeddingIdVendorsRoute
  '/app/w/$weddingId/': typeof AppWWeddingIdIndexRoute
  '/app/w/$weddingId_/print/$kind': typeof AppWWeddingIdPrintKindRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/forgot-password'
    | '/legal'
    | '/login'
    | '/mail-opt-out'
    | '/reset-password'
    | '/signup'
    | '/unsubscribe'
    | '/$lang'
    | '/contact'
    | '/features'
    | '/for-wedding-planners'
    | '/plan-a-wedding-together'
    | '/pricing'
    | '/wedding-budget-app'
    | '/wedding-budget-calculator'
    | '/wedding-checklist'
    | '/wedding-countdown'
    | '/wedding-day-timeline'
    | '/wedding-guest-list-app'
    | '/wedding-guest-list-template'
    | '/wedding-rsvp'
    | '/wedding-seating-chart'
    | '/when-to-send-wedding-invitations'
    | '/app/account'
    | '/app/billing'
    | '/app/new'
    | '/app/planner'
    | '/app/templates'
    | '/auth/app-return'
    | '/join/$token'
    | '/legal/cookies'
    | '/legal/delete-account'
    | '/legal/privacy'
    | '/legal/terms'
    | '/rsvp/$token'
    | '/s/$token'
    | '/app/'
    | '/legal/'
    | '/$lang/features'
    | '/$lang/pricing'
    | '/$lang/wedding-budget-calculator'
    | '/$lang/wedding-checklist'
    | '/$lang/wedding-countdown'
    | '/$lang/wedding-day-timeline'
    | '/$lang/wedding-guest-list-template'
    | '/$lang/wedding-seating-chart'
    | '/$lang/when-to-send-wedding-invitations'
    | '/compare/bridebook-alternative'
    | '/compare/the-knot-alternative'
    | '/compare/zola-alternative'
    | '/guides/how-to-make-a-wedding-seating-chart'
    | '/guides/how-to-plan-a-wedding'
    | '/guides/questions-to-ask-wedding-vendors'
    | '/guides/wedding-budget-breakdown'
    | '/guides/wedding-guest-list-etiquette'
    | '/guides/wedding-rsvp-wording'
    | '/help/import-guest-list'
    | '/help/invite-your-partner'
    | '/help/move'
    | '/help/rsvp-links'
    | '/wedding-checklist/3-months'
    | '/wedding-checklist/6-months'
    | '/wedding-day-timeline/2pm-ceremony'
    | '/wedding-day-timeline/4pm-ceremony'
    | '/wedding-day-timeline/6pm-ceremony'
    | '/app/w/$weddingId'
    | '/$lang/'
    | '/guides/'
    | '/help/'
    | '/app/w/$weddingId/activity'
    | '/app/w/$weddingId/budget'
    | '/app/w/$weddingId/checklist'
    | '/app/w/$weddingId/guests'
    | '/app/w/$weddingId/insights'
    | '/app/w/$weddingId/inspiration'
    | '/app/w/$weddingId/more'
    | '/app/w/$weddingId/notes'
    | '/app/w/$weddingId/payments'
    | '/app/w/$weddingId/people'
    | '/app/w/$weddingId/registry'
    | '/app/w/$weddingId/seating'
    | '/app/w/$weddingId/settings'
    | '/app/w/$weddingId/shopping'
    | '/app/w/$weddingId/timeline'
    | '/app/w/$weddingId/vendors'
    | '/app/w/$weddingId/'
    | '/app/w/$weddingId/print/$kind'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/mail-opt-out'
    | '/reset-password'
    | '/signup'
    | '/unsubscribe'
    | '/contact'
    | '/features'
    | '/for-wedding-planners'
    | '/plan-a-wedding-together'
    | '/pricing'
    | '/wedding-budget-app'
    | '/wedding-budget-calculator'
    | '/wedding-checklist'
    | '/wedding-countdown'
    | '/wedding-day-timeline'
    | '/wedding-guest-list-app'
    | '/wedding-guest-list-template'
    | '/wedding-rsvp'
    | '/wedding-seating-chart'
    | '/when-to-send-wedding-invitations'
    | '/app/account'
    | '/app/billing'
    | '/app/new'
    | '/app/planner'
    | '/app/templates'
    | '/auth/app-return'
    | '/join/$token'
    | '/legal/cookies'
    | '/legal/delete-account'
    | '/legal/privacy'
    | '/legal/terms'
    | '/rsvp/$token'
    | '/s/$token'
    | '/'
    | '/app'
    | '/legal'
    | '/$lang/features'
    | '/$lang/pricing'
    | '/$lang/wedding-budget-calculator'
    | '/$lang/wedding-checklist'
    | '/$lang/wedding-countdown'
    | '/$lang/wedding-day-timeline'
    | '/$lang/wedding-guest-list-template'
    | '/$lang/wedding-seating-chart'
    | '/$lang/when-to-send-wedding-invitations'
    | '/compare/bridebook-alternative'
    | '/compare/the-knot-alternative'
    | '/compare/zola-alternative'
    | '/guides/how-to-make-a-wedding-seating-chart'
    | '/guides/how-to-plan-a-wedding'
    | '/guides/questions-to-ask-wedding-vendors'
    | '/guides/wedding-budget-breakdown'
    | '/guides/wedding-guest-list-etiquette'
    | '/guides/wedding-rsvp-wording'
    | '/help/import-guest-list'
    | '/help/invite-your-partner'
    | '/help/move'
    | '/help/rsvp-links'
    | '/wedding-checklist/3-months'
    | '/wedding-checklist/6-months'
    | '/wedding-day-timeline/2pm-ceremony'
    | '/wedding-day-timeline/4pm-ceremony'
    | '/wedding-day-timeline/6pm-ceremony'
    | '/$lang'
    | '/guides'
    | '/help'
    | '/app/w/$weddingId/activity'
    | '/app/w/$weddingId/budget'
    | '/app/w/$weddingId/checklist'
    | '/app/w/$weddingId/guests'
    | '/app/w/$weddingId/insights'
    | '/app/w/$weddingId/inspiration'
    | '/app/w/$weddingId/more'
    | '/app/w/$weddingId/notes'
    | '/app/w/$weddingId/payments'
    | '/app/w/$weddingId/people'
    | '/app/w/$weddingId/registry'
    | '/app/w/$weddingId/seating'
    | '/app/w/$weddingId/settings'
    | '/app/w/$weddingId/shopping'
    | '/app/w/$weddingId/timeline'
    | '/app/w/$weddingId/vendors'
    | '/app/w/$weddingId'
    | '/app/w/$weddingId/print/$kind'
  id:
    | '__root__'
    | '/_marketing'
    | '/app'
    | '/forgot-password'
    | '/legal'
    | '/login'
    | '/mail-opt-out'
    | '/reset-password'
    | '/signup'
    | '/unsubscribe'
    | '/_marketing/$lang'
    | '/_marketing/contact'
    | '/_marketing/features'
    | '/_marketing/for-wedding-planners'
    | '/_marketing/plan-a-wedding-together'
    | '/_marketing/pricing'
    | '/_marketing/wedding-budget-app'
    | '/_marketing/wedding-budget-calculator'
    | '/_marketing/wedding-checklist'
    | '/_marketing/wedding-countdown'
    | '/_marketing/wedding-day-timeline'
    | '/_marketing/wedding-guest-list-app'
    | '/_marketing/wedding-guest-list-template'
    | '/_marketing/wedding-rsvp'
    | '/_marketing/wedding-seating-chart'
    | '/_marketing/when-to-send-wedding-invitations'
    | '/app/account'
    | '/app/billing'
    | '/app/new'
    | '/app/planner'
    | '/app/templates'
    | '/auth/app-return'
    | '/join/$token'
    | '/legal/cookies'
    | '/legal/delete-account'
    | '/legal/privacy'
    | '/legal/terms'
    | '/rsvp/$token'
    | '/s/$token'
    | '/_marketing/'
    | '/app/'
    | '/legal/'
    | '/_marketing/$lang/features'
    | '/_marketing/$lang/pricing'
    | '/_marketing/$lang/wedding-budget-calculator'
    | '/_marketing/$lang/wedding-checklist'
    | '/_marketing/$lang/wedding-countdown'
    | '/_marketing/$lang/wedding-day-timeline'
    | '/_marketing/$lang/wedding-guest-list-template'
    | '/_marketing/$lang/wedding-seating-chart'
    | '/_marketing/$lang/when-to-send-wedding-invitations'
    | '/_marketing/compare/bridebook-alternative'
    | '/_marketing/compare/the-knot-alternative'
    | '/_marketing/compare/zola-alternative'
    | '/_marketing/guides/how-to-make-a-wedding-seating-chart'
    | '/_marketing/guides/how-to-plan-a-wedding'
    | '/_marketing/guides/questions-to-ask-wedding-vendors'
    | '/_marketing/guides/wedding-budget-breakdown'
    | '/_marketing/guides/wedding-guest-list-etiquette'
    | '/_marketing/guides/wedding-rsvp-wording'
    | '/_marketing/help/import-guest-list'
    | '/_marketing/help/invite-your-partner'
    | '/_marketing/help/move'
    | '/_marketing/help/rsvp-links'
    | '/_marketing/wedding-checklist_/3-months'
    | '/_marketing/wedding-checklist_/6-months'
    | '/_marketing/wedding-day-timeline_/2pm-ceremony'
    | '/_marketing/wedding-day-timeline_/4pm-ceremony'
    | '/_marketing/wedding-day-timeline_/6pm-ceremony'
    | '/app/w/$weddingId'
    | '/_marketing/$lang/'
    | '/_marketing/guides/'
    | '/_marketing/help/'
    | '/app/w/$weddingId/activity'
    | '/app/w/$weddingId/budget'
    | '/app/w/$weddingId/checklist'
    | '/app/w/$weddingId/guests'
    | '/app/w/$weddingId/insights'
    | '/app/w/$weddingId/inspiration'
    | '/app/w/$weddingId/more'
    | '/app/w/$weddingId/notes'
    | '/app/w/$weddingId/payments'
    | '/app/w/$weddingId/people'
    | '/app/w/$weddingId/registry'
    | '/app/w/$weddingId/seating'
    | '/app/w/$weddingId/settings'
    | '/app/w/$weddingId/shopping'
    | '/app/w/$weddingId/timeline'
    | '/app/w/$weddingId/vendors'
    | '/app/w/$weddingId/'
    | '/app/w/$weddingId_/print/$kind'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  MarketingRoute: typeof MarketingRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LegalRoute: typeof LegalRouteWithChildren
  LoginRoute: typeof LoginRoute
  MailOptOutRoute: typeof MailOptOutRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  UnsubscribeRoute: typeof UnsubscribeRoute
  AuthAppReturnRoute: typeof AuthAppReturnRoute
  JoinTokenRoute: typeof JoinTokenRoute
  RsvpTokenRoute: typeof RsvpTokenRoute
  STokenRoute: typeof STokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_marketing': {
      id: '/_marketing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mail-opt-out': {
      id: '/mail-opt-out'
      path: '/mail-opt-out'
      fullPath: '/mail-opt-out'
      preLoaderRoute: typeof MailOptOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_marketing/': {
      id: '/_marketing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MarketingIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/$lang': {
      id: '/_marketing/$lang'
      path: '/$lang'
      fullPath: '/$lang'
      preLoaderRoute: typeof MarketingLangRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/contact': {
      id: '/_marketing/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof MarketingContactRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/features': {
      id: '/_marketing/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof MarketingFeaturesRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/for-wedding-planners': {
      id: '/_marketing/for-wedding-planners'
      path: '/for-wedding-planners'
      fullPath: '/for-wedding-planners'
      preLoaderRoute: typeof MarketingForWeddingPlannersRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/plan-a-wedding-together': {
      id: '/_marketing/plan-a-wedding-together'
      path: '/plan-a-wedding-together'
      fullPath: '/plan-a-wedding-together'
      preLoaderRoute: typeof MarketingPlanAWeddingTogetherRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/pricing': {
      id: '/_marketing/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof MarketingPricingRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/wedding-budget-app': {
      id: '/_marketing/wedding-budget-app'
      path: '/wedding-budget-app'
      fullPath: '/wedding-budget-app'
      preLoaderRoute: typeof MarketingWeddingBudgetAppRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/wedding-budget-calculator': {
      id: '/_marketing/wedding-budget-calculator'
      path: '/wedding-budget-calculator'
      fullPath: '/wedding-budget-calculator'
      preLoaderRoute: typeof MarketingWeddingBudgetCalculatorRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/wedding-checklist': {
      id: '/_marketing/wedding-checklist'
      path: '/wedding-checklist'
      fullPath: '/wedding-checklist'
      preLoaderRoute: typeof MarketingWeddingChecklistRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/wedding-countdown': {
      id: '/_marketing/wedding-countdown'
      path: '/wedding-countdown'
      fullPath: '/wedding-countdown'
      preLoaderRoute: typeof MarketingWeddingCountdownRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/wedding-day-timeline': {
      id: '/_marketing/wedding-day-timeline'
      path: '/wedding-day-timeline'
      fullPath: '/wedding-day-timeline'
      preLoaderRoute: typeof MarketingWeddingDayTimelineRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/wedding-guest-list-app': {
      id: '/_marketing/wedding-guest-list-app'
      path: '/wedding-guest-list-app'
      fullPath: '/wedding-guest-list-app'
      preLoaderRoute: typeof MarketingWeddingGuestListAppRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/wedding-guest-list-template': {
      id: '/_marketing/wedding-guest-list-template'
      path: '/wedding-guest-list-template'
      fullPath: '/wedding-guest-list-template'
      preLoaderRoute: typeof MarketingWeddingGuestListTemplateRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/wedding-rsvp': {
      id: '/_marketing/wedding-rsvp'
      path: '/wedding-rsvp'
      fullPath: '/wedding-rsvp'
      preLoaderRoute: typeof MarketingWeddingRsvpRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/wedding-seating-chart': {
      id: '/_marketing/wedding-seating-chart'
      path: '/wedding-seating-chart'
      fullPath: '/wedding-seating-chart'
      preLoaderRoute: typeof MarketingWeddingSeatingChartRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/when-to-send-wedding-invitations': {
      id: '/_marketing/when-to-send-wedding-invitations'
      path: '/when-to-send-wedding-invitations'
      fullPath: '/when-to-send-wedding-invitations'
      preLoaderRoute: typeof MarketingWhenToSendWeddingInvitationsRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/account': {
      id: '/app/account'
      path: '/account'
      fullPath: '/app/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/billing': {
      id: '/app/billing'
      path: '/billing'
      fullPath: '/app/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/new': {
      id: '/app/new'
      path: '/new'
      fullPath: '/app/new'
      preLoaderRoute: typeof AppNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/planner': {
      id: '/app/planner'
      path: '/planner'
      fullPath: '/app/planner'
      preLoaderRoute: typeof AppPlannerRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/templates': {
      id: '/app/templates'
      path: '/templates'
      fullPath: '/app/templates'
      preLoaderRoute: typeof AppTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/app-return': {
      id: '/auth/app-return'
      path: '/auth/app-return'
      fullPath: '/auth/app-return'
      preLoaderRoute: typeof AuthAppReturnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/$token': {
      id: '/join/$token'
      path: '/join/$token'
      fullPath: '/join/$token'
      preLoaderRoute: typeof JoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/': {
      id: '/legal/'
      path: '/'
      fullPath: '/legal/'
      preLoaderRoute: typeof LegalIndexRouteImport
      parentRoute: typeof LegalRoute
    }
    '/legal/cookies': {
      id: '/legal/cookies'
      path: '/cookies'
      fullPath: '/legal/cookies'
      preLoaderRoute: typeof LegalCookiesRouteImport
      parentRoute: typeof LegalRoute
    }
    '/legal/delete-account': {
      id: '/legal/delete-account'
      path: '/delete-account'
      fullPath: '/legal/delete-account'
      preLoaderRoute: typeof LegalDeleteAccountRouteImport
      parentRoute: typeof LegalRoute
    }
    '/legal/privacy': {
      id: '/legal/privacy'
      path: '/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof LegalPrivacyRouteImport
      parentRoute: typeof LegalRoute
    }
    '/legal/terms': {
      id: '/legal/terms'
      path: '/terms'
      fullPath: '/legal/terms'
      preLoaderRoute: typeof LegalTermsRouteImport
      parentRoute: typeof LegalRoute
    }
    '/rsvp/$token': {
      id: '/rsvp/$token'
      path: '/rsvp/$token'
      fullPath: '/rsvp/$token'
      preLoaderRoute: typeof RsvpTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_marketing/$lang/': {
      id: '/_marketing/$lang/'
      path: '/'
      fullPath: '/$lang/'
      preLoaderRoute: typeof MarketingLangIndexRouteImport
      parentRoute: typeof MarketingLangRoute
    }
    '/_marketing/$lang/features': {
      id: '/_marketing/$lang/features'
      path: '/features'
      fullPath: '/$lang/features'
      preLoaderRoute: typeof MarketingLangFeaturesRouteImport
      parentRoute: typeof MarketingLangRoute
    }
    '/_marketing/$lang/pricing': {
      id: '/_marketing/$lang/pricing'
      path: '/pricing'
      fullPath: '/$lang/pricing'
      preLoaderRoute: typeof MarketingLangPricingRouteImport
      parentRoute: typeof MarketingLangRoute
    }
    '/_marketing/$lang/wedding-budget-calculator': {
      id: '/_marketing/$lang/wedding-budget-calculator'
      path: '/wedding-budget-calculator'
      fullPath: '/$lang/wedding-budget-calculator'
      preLoaderRoute: typeof MarketingLangWeddingBudgetCalculatorRouteImport
      parentRoute: typeof MarketingLangRoute
    }
    '/_marketing/$lang/wedding-checklist': {
      id: '/_marketing/$lang/wedding-checklist'
      path: '/wedding-checklist'
      fullPath: '/$lang/wedding-checklist'
      preLoaderRoute: typeof MarketingLangWeddingChecklistRouteImport
      parentRoute: typeof MarketingLangRoute
    }
    '/_marketing/$lang/wedding-countdown': {
      id: '/_marketing/$lang/wedding-countdown'
      path: '/wedding-countdown'
      fullPath: '/$lang/wedding-countdown'
      preLoaderRoute: typeof MarketingLangWeddingCountdownRouteImport
      parentRoute: typeof MarketingLangRoute
    }
    '/_marketing/$lang/wedding-day-timeline': {
      id: '/_marketing/$lang/wedding-day-timeline'
      path: '/wedding-day-timeline'
      fullPath: '/$lang/wedding-day-timeline'
      preLoaderRoute: typeof MarketingLangWeddingDayTimelineRouteImport
      parentRoute: typeof MarketingLangRoute
    }
    '/_marketing/$lang/wedding-guest-list-template': {
      id: '/_marketing/$lang/wedding-guest-list-template'
      path: '/wedding-guest-list-template'
      fullPath: '/$lang/wedding-guest-list-template'
      preLoaderRoute: typeof MarketingLangWeddingGuestListTemplateRouteImport
      parentRoute: typeof MarketingLangRoute
    }
    '/_marketing/$lang/wedding-seating-chart': {
      id: '/_marketing/$lang/wedding-seating-chart'
      path: '/wedding-seating-chart'
      fullPath: '/$lang/wedding-seating-chart'
      preLoaderRoute: typeof MarketingLangWeddingSeatingChartRouteImport
      parentRoute: typeof MarketingLangRoute
    }
    '/_marketing/$lang/when-to-send-wedding-invitations': {
      id: '/_marketing/$lang/when-to-send-wedding-invitations'
      path: '/when-to-send-wedding-invitations'
      fullPath: '/$lang/when-to-send-wedding-invitations'
      preLoaderRoute: typeof MarketingLangWhenToSendWeddingInvitationsRouteImport
      parentRoute: typeof MarketingLangRoute
    }
    '/_marketing/compare/bridebook-alternative': {
      id: '/_marketing/compare/bridebook-alternative'
      path: '/compare/bridebook-alternative'
      fullPath: '/compare/bridebook-alternative'
      preLoaderRoute: typeof MarketingCompareBridebookAlternativeRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/compare/the-knot-alternative': {
      id: '/_marketing/compare/the-knot-alternative'
      path: '/compare/the-knot-alternative'
      fullPath: '/compare/the-knot-alternative'
      preLoaderRoute: typeof MarketingCompareTheKnotAlternativeRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/compare/zola-alternative': {
      id: '/_marketing/compare/zola-alternative'
      path: '/compare/zola-alternative'
      fullPath: '/compare/zola-alternative'
      preLoaderRoute: typeof MarketingCompareZolaAlternativeRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/guides/': {
      id: '/_marketing/guides/'
      path: '/guides'
      fullPath: '/guides/'
      preLoaderRoute: typeof MarketingGuidesIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/guides/how-to-make-a-wedding-seating-chart': {
      id: '/_marketing/guides/how-to-make-a-wedding-seating-chart'
      path: '/guides/how-to-make-a-wedding-seating-chart'
      fullPath: '/guides/how-to-make-a-wedding-seating-chart'
      preLoaderRoute: typeof MarketingGuidesHowToMakeAWeddingSeatingChartRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/guides/how-to-plan-a-wedding': {
      id: '/_marketing/guides/how-to-plan-a-wedding'
      path: '/guides/how-to-plan-a-wedding'
      fullPath: '/guides/how-to-plan-a-wedding'
      preLoaderRoute: typeof MarketingGuidesHowToPlanAWeddingRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/guides/questions-to-ask-wedding-vendors': {
      id: '/_marketing/guides/questions-to-ask-wedding-vendors'
      path: '/guides/questions-to-ask-wedding-vendors'
      fullPath: '/guides/questions-to-ask-wedding-vendors'
      preLoaderRoute: typeof MarketingGuidesQuestionsToAskWeddingVendorsRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/guides/wedding-budget-breakdown': {
      id: '/_marketing/guides/wedding-budget-breakdown'
      path: '/guides/wedding-budget-breakdown'
      fullPath: '/guides/wedding-budget-breakdown'
      preLoaderRoute: typeof MarketingGuidesWeddingBudgetBreakdownRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/guides/wedding-guest-list-etiquette': {
      id: '/_marketing/guides/wedding-guest-list-etiquette'
      path: '/guides/wedding-guest-list-etiquette'
      fullPath: '/guides/wedding-guest-list-etiquette'
      preLoaderRoute: typeof MarketingGuidesWeddingGuestListEtiquetteRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/guides/wedding-rsvp-wording': {
      id: '/_marketing/guides/wedding-rsvp-wording'
      path: '/guides/wedding-rsvp-wording'
      fullPath: '/guides/wedding-rsvp-wording'
      preLoaderRoute: typeof MarketingGuidesWeddingRsvpWordingRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/help/': {
      id: '/_marketing/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof MarketingHelpIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/help/import-guest-list': {
      id: '/_marketing/help/import-guest-list'
      path: '/help/import-guest-list'
      fullPath: '/help/import-guest-list'
      preLoaderRoute: typeof MarketingHelpImportGuestListRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/help/invite-your-partner': {
      id: '/_marketing/help/invite-your-partner'
      path: '/help/invite-your-partner'
      fullPath: '/help/invite-your-partner'
      preLoaderRoute: typeof MarketingHelpInviteYourPartnerRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/help/move': {
      id: '/_marketing/help/move'
      path: '/help/move'
      fullPath: '/help/move'
      preLoaderRoute: typeof MarketingHelpMoveRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/help/rsvp-links': {
      id: '/_marketing/help/rsvp-links'
      path: '/help/rsvp-links'
      fullPath: '/help/rsvp-links'
      preLoaderRoute: typeof MarketingHelpRsvpLinksRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/wedding-checklist_/3-months': {
      id: '/_marketing/wedding-checklist_/3-months'
      path: '/wedding-checklist/3-months'
      fullPath: '/wedding-checklist/3-months'
      preLoaderRoute: typeof MarketingWeddingChecklist3MonthsRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/wedding-checklist_/6-months': {
      id: '/_marketing/wedding-checklist_/6-months'
      path: '/wedding-checklist/6-months'
      fullPath: '/wedding-checklist/6-months'
      preLoaderRoute: typeof MarketingWeddingChecklist6MonthsRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/wedding-day-timeline_/2pm-ceremony': {
      id: '/_marketing/wedding-day-timeline_/2pm-ceremony'
      path: '/wedding-day-timeline/2pm-ceremony'
      fullPath: '/wedding-day-timeline/2pm-ceremony'
      preLoaderRoute: typeof MarketingWeddingDayTimeline2pmCeremonyRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/wedding-day-timeline_/4pm-ceremony': {
      id: '/_marketing/wedding-day-timeline_/4pm-ceremony'
      path: '/wedding-day-timeline/4pm-ceremony'
      fullPath: '/wedding-day-timeline/4pm-ceremony'
      preLoaderRoute: typeof MarketingWeddingDayTimeline4pmCeremonyRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/wedding-day-timeline_/6pm-ceremony': {
      id: '/_marketing/wedding-day-timeline_/6pm-ceremony'
      path: '/wedding-day-timeline/6pm-ceremony'
      fullPath: '/wedding-day-timeline/6pm-ceremony'
      preLoaderRoute: typeof MarketingWeddingDayTimeline6pmCeremonyRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/app/w/$weddingId': {
      id: '/app/w/$weddingId'
      path: '/w/$weddingId'
      fullPath: '/app/w/$weddingId'
      preLoaderRoute: typeof AppWWeddingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/w/$weddingId/': {
      id: '/app/w/$weddingId/'
      path: '/'
      fullPath: '/app/w/$weddingId/'
      preLoaderRoute: typeof AppWWeddingIdIndexRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/activity': {
      id: '/app/w/$weddingId/activity'
      path: '/activity'
      fullPath: '/app/w/$weddingId/activity'
      preLoaderRoute: typeof AppWWeddingIdActivityRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/budget': {
      id: '/app/w/$weddingId/budget'
      path: '/budget'
      fullPath: '/app/w/$weddingId/budget'
      preLoaderRoute: typeof AppWWeddingIdBudgetRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/checklist': {
      id: '/app/w/$weddingId/checklist'
      path: '/checklist'
      fullPath: '/app/w/$weddingId/checklist'
      preLoaderRoute: typeof AppWWeddingIdChecklistRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/guests': {
      id: '/app/w/$weddingId/guests'
      path: '/guests'
      fullPath: '/app/w/$weddingId/guests'
      preLoaderRoute: typeof AppWWeddingIdGuestsRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/insights': {
      id: '/app/w/$weddingId/insights'
      path: '/insights'
      fullPath: '/app/w/$weddingId/insights'
      preLoaderRoute: typeof AppWWeddingIdInsightsRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/inspiration': {
      id: '/app/w/$weddingId/inspiration'
      path: '/inspiration'
      fullPath: '/app/w/$weddingId/inspiration'
      preLoaderRoute: typeof AppWWeddingIdInspirationRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/more': {
      id: '/app/w/$weddingId/more'
      path: '/more'
      fullPath: '/app/w/$weddingId/more'
      preLoaderRoute: typeof AppWWeddingIdMoreRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/notes': {
      id: '/app/w/$weddingId/notes'
      path: '/notes'
      fullPath: '/app/w/$weddingId/notes'
      preLoaderRoute: typeof AppWWeddingIdNotesRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/payments': {
      id: '/app/w/$weddingId/payments'
      path: '/payments'
      fullPath: '/app/w/$weddingId/payments'
      preLoaderRoute: typeof AppWWeddingIdPaymentsRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/people': {
      id: '/app/w/$weddingId/people'
      path: '/people'
      fullPath: '/app/w/$weddingId/people'
      preLoaderRoute: typeof AppWWeddingIdPeopleRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/registry': {
      id: '/app/w/$weddingId/registry'
      path: '/registry'
      fullPath: '/app/w/$weddingId/registry'
      preLoaderRoute: typeof AppWWeddingIdRegistryRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/seating': {
      id: '/app/w/$weddingId/seating'
      path: '/seating'
      fullPath: '/app/w/$weddingId/seating'
      preLoaderRoute: typeof AppWWeddingIdSeatingRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/settings': {
      id: '/app/w/$weddingId/settings'
      path: '/settings'
      fullPath: '/app/w/$weddingId/settings'
      preLoaderRoute: typeof AppWWeddingIdSettingsRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/shopping': {
      id: '/app/w/$weddingId/shopping'
      path: '/shopping'
      fullPath: '/app/w/$weddingId/shopping'
      preLoaderRoute: typeof AppWWeddingIdShoppingRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/timeline': {
      id: '/app/w/$weddingId/timeline'
      path: '/timeline'
      fullPath: '/app/w/$weddingId/timeline'
      preLoaderRoute: typeof AppWWeddingIdTimelineRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId/vendors': {
      id: '/app/w/$weddingId/vendors'
      path: '/vendors'
      fullPath: '/app/w/$weddingId/vendors'
      preLoaderRoute: typeof AppWWeddingIdVendorsRouteImport
      parentRoute: typeof AppWWeddingIdRoute
    }
    '/app/w/$weddingId_/print/$kind': {
      id: '/app/w/$weddingId_/print/$kind'
      path: '/w/$weddingId/print/$kind'
      fullPath: '/app/w/$weddingId/print/$kind'
      preLoaderRoute: typeof AppWWeddingIdPrintKindRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface MarketingLangRouteChildren {
  MarketingLangFeaturesRoute: typeof MarketingLangFeaturesRoute
  MarketingLangPricingRoute: typeof MarketingLangPricingRoute
  MarketingLangWeddingBudgetCalculatorRoute: typeof MarketingLangWeddingBudgetCalculatorRoute
  MarketingLangWeddingChecklistRoute: typeof MarketingLangWeddingChecklistRoute
  MarketingLangWeddingCountdownRoute: typeof MarketingLangWeddingCountdownRoute
  MarketingLangWeddingDayTimelineRoute: typeof MarketingLangWeddingDayTimelineRoute
  MarketingLangWeddingGuestListTemplateRoute: typeof MarketingLangWeddingGuestListTemplateRoute
  MarketingLangWeddingSeatingChartRoute: typeof MarketingLangWeddingSeatingChartRoute
  MarketingLangWhenToSendWeddingInvitationsRoute: typeof MarketingLangWhenToSendWeddingInvitationsRoute
  MarketingLangIndexRoute: typeof MarketingLangIndexRoute
}

const MarketingLangRouteChildren: MarketingLangRouteChildren = {
  MarketingLangFeaturesRoute: MarketingLangFeaturesRoute,
  MarketingLangPricingRoute: MarketingLangPricingRoute,
  MarketingLangWeddingBudgetCalculatorRoute:
    MarketingLangWeddingBudgetCalculatorRoute,
  MarketingLangWeddingChecklistRoute: MarketingLangWeddingChecklistRoute,
  MarketingLangWeddingCountdownRoute: MarketingLangWeddingCountdownRoute,
  MarketingLangWeddingDayTimelineRoute: MarketingLangWeddingDayTimelineRoute,
  MarketingLangWeddingGuestListTemplateRoute:
    MarketingLangWeddingGuestListTemplateRoute,
  MarketingLangWeddingSeatingChartRoute: MarketingLangWeddingSeatingChartRoute,
  MarketingLangWhenToSendWeddingInvitationsRoute:
    MarketingLangWhenToSendWeddingInvitationsRoute,
  MarketingLangIndexRoute: MarketingLangIndexRoute,
}

const MarketingLangRouteWithChildren = MarketingLangRoute._addFileChildren(
  MarketingLangRouteChildren,
)

interface MarketingRouteChildren {
  MarketingLangRoute: typeof MarketingLangRouteWithChildren
  MarketingContactRoute: typeof MarketingContactRoute
  MarketingFeaturesRoute: typeof MarketingFeaturesRoute
  MarketingForWeddingPlannersRoute: typeof MarketingForWeddingPlannersRoute
  MarketingPlanAWeddingTogetherRoute: typeof MarketingPlanAWeddingTogetherRoute
  MarketingPricingRoute: typeof MarketingPricingRoute
  MarketingWeddingBudgetAppRoute: typeof MarketingWeddingBudgetAppRoute
  MarketingWeddingBudgetCalculatorRoute: typeof MarketingWeddingBudgetCalculatorRoute
  MarketingWeddingChecklistRoute: typeof MarketingWeddingChecklistRoute
  MarketingWeddingCountdownRoute: typeof MarketingWeddingCountdownRoute
  MarketingWeddingDayTimelineRoute: typeof MarketingWeddingDayTimelineRoute
  MarketingWeddingGuestListAppRoute: typeof MarketingWeddingGuestListAppRoute
  MarketingWeddingGuestListTemplateRoute: typeof MarketingWeddingGuestListTemplateRoute
  MarketingWeddingRsvpRoute: typeof MarketingWeddingRsvpRoute
  MarketingWeddingSeatingChartRoute: typeof MarketingWeddingSeatingChartRoute
  MarketingWhenToSendWeddingInvitationsRoute: typeof MarketingWhenToSendWeddingInvitationsRoute
  MarketingIndexRoute: typeof MarketingIndexRoute
  MarketingCompareBridebookAlternativeRoute: typeof MarketingCompareBridebookAlternativeRoute
  MarketingCompareTheKnotAlternativeRoute: typeof MarketingCompareTheKnotAlternativeRoute
  MarketingCompareZolaAlternativeRoute: typeof MarketingCompareZolaAlternativeRoute
  MarketingGuidesHowToMakeAWeddingSeatingChartRoute: typeof MarketingGuidesHowToMakeAWeddingSeatingChartRoute
  MarketingGuidesHowToPlanAWeddingRoute: typeof MarketingGuidesHowToPlanAWeddingRoute
  MarketingGuidesQuestionsToAskWeddingVendorsRoute: typeof MarketingGuidesQuestionsToAskWeddingVendorsRoute
  MarketingGuidesWeddingBudgetBreakdownRoute: typeof MarketingGuidesWeddingBudgetBreakdownRoute
  MarketingGuidesWeddingGuestListEtiquetteRoute: typeof MarketingGuidesWeddingGuestListEtiquetteRoute
  MarketingGuidesWeddingRsvpWordingRoute: typeof MarketingGuidesWeddingRsvpWordingRoute
  MarketingHelpImportGuestListRoute: typeof MarketingHelpImportGuestListRoute
  MarketingHelpInviteYourPartnerRoute: typeof MarketingHelpInviteYourPartnerRoute
  MarketingHelpMoveRoute: typeof MarketingHelpMoveRoute
  MarketingHelpRsvpLinksRoute: typeof MarketingHelpRsvpLinksRoute
  MarketingWeddingChecklist3MonthsRoute: typeof MarketingWeddingChecklist3MonthsRoute
  MarketingWeddingChecklist6MonthsRoute: typeof MarketingWeddingChecklist6MonthsRoute
  MarketingWeddingDayTimeline2pmCeremonyRoute: typeof MarketingWeddingDayTimeline2pmCeremonyRoute
  MarketingWeddingDayTimeline4pmCeremonyRoute: typeof MarketingWeddingDayTimeline4pmCeremonyRoute
  MarketingWeddingDayTimeline6pmCeremonyRoute: typeof MarketingWeddingDayTimeline6pmCeremonyRoute
  MarketingGuidesIndexRoute: typeof MarketingGuidesIndexRoute
  MarketingHelpIndexRoute: typeof MarketingHelpIndexRoute
}

const MarketingRouteChildren: MarketingRouteChildren = {
  MarketingLangRoute: MarketingLangRouteWithChildren,
  MarketingContactRoute: MarketingContactRoute,
  MarketingFeaturesRoute: MarketingFeaturesRoute,
  MarketingForWeddingPlannersRoute: MarketingForWeddingPlannersRoute,
  MarketingPlanAWeddingTogetherRoute: MarketingPlanAWeddingTogetherRoute,
  MarketingPricingRoute: MarketingPricingRoute,
  MarketingWeddingBudgetAppRoute: MarketingWeddingBudgetAppRoute,
  MarketingWeddingBudgetCalculatorRoute: MarketingWeddingBudgetCalculatorRoute,
  MarketingWeddingChecklistRoute: MarketingWeddingChecklistRoute,
  MarketingWeddingCountdownRoute: MarketingWeddingCountdownRoute,
  MarketingWeddingDayTimelineRoute: MarketingWeddingDayTimelineRoute,
  MarketingWeddingGuestListAppRoute: MarketingWeddingGuestListAppRoute,
  MarketingWeddingGuestListTemplateRoute:
    MarketingWeddingGuestListTemplateRoute,
  MarketingWeddingRsvpRoute: MarketingWeddingRsvpRoute,
  MarketingWeddingSeatingChartRoute: MarketingWeddingSeatingChartRoute,
  MarketingWhenToSendWeddingInvitationsRoute:
    MarketingWhenToSendWeddingInvitationsRoute,
  MarketingIndexRoute: MarketingIndexRoute,
  MarketingCompareBridebookAlternativeRoute:
    MarketingCompareBridebookAlternativeRoute,
  MarketingCompareTheKnotAlternativeRoute:
    MarketingCompareTheKnotAlternativeRoute,
  MarketingCompareZolaAlternativeRoute: MarketingCompareZolaAlternativeRoute,
  MarketingGuidesHowToMakeAWeddingSeatingChartRoute:
    MarketingGuidesHowToMakeAWeddingSeatingChartRoute,
  MarketingGuidesHowToPlanAWeddingRoute: MarketingGuidesHowToPlanAWeddingRoute,
  MarketingGuidesQuestionsToAskWeddingVendorsRoute:
    MarketingGuidesQuestionsToAskWeddingVendorsRoute,
  MarketingGuidesWeddingBudgetBreakdownRoute:
    MarketingGuidesWeddingBudgetBreakdownRoute,
  MarketingGuidesWeddingGuestListEtiquetteRoute:
    MarketingGuidesWeddingGuestListEtiquetteRoute,
  MarketingGuidesWeddingRsvpWordingRoute:
    MarketingGuidesWeddingRsvpWordingRoute,
  MarketingHelpImportGuestListRoute: MarketingHelpImportGuestListRoute,
  MarketingHelpInviteYourPartnerRoute: MarketingHelpInviteYourPartnerRoute,
  MarketingHelpMoveRoute: MarketingHelpMoveRoute,
  MarketingHelpRsvpLinksRoute: MarketingHelpRsvpLinksRoute,
  MarketingWeddingChecklist3MonthsRoute: MarketingWeddingChecklist3MonthsRoute,
  MarketingWeddingChecklist6MonthsRoute: MarketingWeddingChecklist6MonthsRoute,
  MarketingWeddingDayTimeline2pmCeremonyRoute:
    MarketingWeddingDayTimeline2pmCeremonyRoute,
  MarketingWeddingDayTimeline4pmCeremonyRoute:
    MarketingWeddingDayTimeline4pmCeremonyRoute,
  MarketingWeddingDayTimeline6pmCeremonyRoute:
    MarketingWeddingDayTimeline6pmCeremonyRoute,
  MarketingGuidesIndexRoute: MarketingGuidesIndexRoute,
  MarketingHelpIndexRoute: MarketingHelpIndexRoute,
}

const MarketingRouteWithChildren = MarketingRoute._addFileChildren(
  MarketingRouteChildren,
)

interface AppWWeddingIdRouteChildren {
  AppWWeddingIdActivityRoute: typeof AppWWeddingIdActivityRoute
  AppWWeddingIdBudgetRoute: typeof AppWWeddingIdBudgetRoute
  AppWWeddingIdChecklistRoute: typeof AppWWeddingIdChecklistRoute
  AppWWeddingIdGuestsRoute: typeof AppWWeddingIdGuestsRoute
  AppWWeddingIdInsightsRoute: typeof AppWWeddingIdInsightsRoute
  AppWWeddingIdInspirationRoute: typeof AppWWeddingIdInspirationRoute
  AppWWeddingIdMoreRoute: typeof AppWWeddingIdMoreRoute
  AppWWeddingIdNotesRoute: typeof AppWWeddingIdNotesRoute
  AppWWeddingIdPaymentsRoute: typeof AppWWeddingIdPaymentsRoute
  AppWWeddingIdPeopleRoute: typeof AppWWeddingIdPeopleRoute
  AppWWeddingIdRegistryRoute: typeof AppWWeddingIdRegistryRoute
  AppWWeddingIdSeatingRoute: typeof AppWWeddingIdSeatingRoute
  AppWWeddingIdSettingsRoute: typeof AppWWeddingIdSettingsRoute
  AppWWeddingIdShoppingRoute: typeof AppWWeddingIdShoppingRoute
  AppWWeddingIdTimelineRoute: typeof AppWWeddingIdTimelineRoute
  AppWWeddingIdVendorsRoute: typeof AppWWeddingIdVendorsRoute
  AppWWeddingIdIndexRoute: typeof AppWWeddingIdIndexRoute
}

const AppWWeddingIdRouteChildren: AppWWeddingIdRouteChildren = {
  AppWWeddingIdActivityRoute: AppWWeddingIdActivityRoute,
  AppWWeddingIdBudgetRoute: AppWWeddingIdBudgetRoute,
  AppWWeddingIdChecklistRoute: AppWWeddingIdChecklistRoute,
  AppWWeddingIdGuestsRoute: AppWWeddingIdGuestsRoute,
  AppWWeddingIdInsightsRoute: AppWWeddingIdInsightsRoute,
  AppWWeddingIdInspirationRoute: AppWWeddingIdInspirationRoute,
  AppWWeddingIdMoreRoute: AppWWeddingIdMoreRoute,
  AppWWeddingIdNotesRoute: AppWWeddingIdNotesRoute,
  AppWWeddingIdPaymentsRoute: AppWWeddingIdPaymentsRoute,
  AppWWeddingIdPeopleRoute: AppWWeddingIdPeopleRoute,
  AppWWeddingIdRegistryRoute: AppWWeddingIdRegistryRoute,
  AppWWeddingIdSeatingRoute: AppWWeddingIdSeatingRoute,
  AppWWeddingIdSettingsRoute: AppWWeddingIdSettingsRoute,
  AppWWeddingIdShoppingRoute: AppWWeddingIdShoppingRoute,
  AppWWeddingIdTimelineRoute: AppWWeddingIdTimelineRoute,
  AppWWeddingIdVendorsRoute: AppWWeddingIdVendorsRoute,
  AppWWeddingIdIndexRoute: AppWWeddingIdIndexRoute,
}

const AppWWeddingIdRouteWithChildren = AppWWeddingIdRoute._addFileChildren(
  AppWWeddingIdRouteChildren,
)

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppBillingRoute: typeof AppBillingRoute
  AppNewRoute: typeof AppNewRoute
  AppPlannerRoute: typeof AppPlannerRoute
  AppTemplatesRoute: typeof AppTemplatesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppWWeddingIdRoute: typeof AppWWeddingIdRouteWithChildren
  AppWWeddingIdPrintKindRoute: typeof AppWWeddingIdPrintKindRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppBillingRoute: AppBillingRoute,
  AppNewRoute: AppNewRoute,
  AppPlannerRoute: AppPlannerRoute,
  AppTemplatesRoute: AppTemplatesRoute,
  AppIndexRoute: AppIndexRoute,
  AppWWeddingIdRoute: AppWWeddingIdRouteWithChildren,
  AppWWeddingIdPrintKindRoute: AppWWeddingIdPrintKindRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface LegalRouteChildren {
  LegalCookiesRoute: typeof LegalCookiesRoute
  LegalDeleteAccountRoute: typeof LegalDeleteAccountRoute
  LegalPrivacyRoute: typeof LegalPrivacyRoute
  LegalTermsRoute: typeof LegalTermsRoute
  LegalIndexRoute: typeof LegalIndexRoute
}

const LegalRouteChildren: LegalRouteChildren = {
  LegalCookiesRoute: LegalCookiesRoute,
  LegalDeleteAccountRoute: LegalDeleteAccountRoute,
  LegalPrivacyRoute: LegalPrivacyRoute,
  LegalTermsRoute: LegalTermsRoute,
  LegalIndexRoute: LegalIndexRoute,
}

const LegalRouteWithChildren = LegalRoute._addFileChildren(LegalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  MarketingRoute: MarketingRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LegalRoute: LegalRouteWithChildren,
  LoginRoute: LoginRoute,
  MailOptOutRoute: MailOptOutRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  UnsubscribeRoute: UnsubscribeRoute,
  AuthAppReturnRoute: AuthAppReturnRoute,
  JoinTokenRoute: JoinTokenRoute,
  RsvpTokenRoute: RsvpTokenRoute,
  STokenRoute: STokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
